import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../../components/ui/table";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../../../components/ui/select";
import type { ParsedColumn } from "../../../../../models/audit/sampleUpload";

interface ExistingAttribute {
  id: string;
  name: string;
  type: string;
  sourceRowDisplay: boolean;
}

interface ColumnMappingTableProps {
  columns: ParsedColumn[];
  existingAttributes: ExistingAttribute[];
  columnMappings: Map<number, string | null>;
  onMappingChange: (columnIndex: number, attributeId: string | null) => void;
}

export function ColumnMappingTable({
  columns,
  existingAttributes,
  columnMappings,
  onMappingChange,
}: ColumnMappingTableProps) {
  return (
    <div className="space-y-3">
      <div>
        <h3 className="text-xs font-semibold text-stone-500 uppercase tracking-wide">
          Map Columns to Attributes
        </h3>
        <p className="text-xs text-stone-400 mt-1">
          Select which existing attribute each column should map to
        </p>
      </div>

      <div className="border rounded-lg overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>File Column</TableHead>
              <TableHead className="w-64">Map to Attribute</TableHead>
              <TableHead>Sample Values</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {columns.map((column) => (
              <TableRow key={column.columnIndex}>
                <TableCell className="font-medium">
                  {column.columnName}
                </TableCell>
                <TableCell>
                  <Select
                    value={columnMappings.get(column.columnIndex) ?? "unmapped"}
                    onValueChange={(value) =>
                      onMappingChange(
                        column.columnIndex,
                        value === "unmapped" ? null : value,
                      )
                    }
                  >
                    <SelectTrigger className="h-8 text-sm">
                      <SelectValue placeholder="Select attribute..." />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="unmapped">
                        <span className="text-stone-400">Don't import</span>
                      </SelectItem>
                      {existingAttributes
                        .filter((attr) => attr.sourceRowDisplay)
                        .map((attr) => (
                          <SelectItem key={attr.id} value={attr.id}>
                            {attr.name}
                          </SelectItem>
                        ))}
                    </SelectContent>
                  </Select>
                </TableCell>
                <TableCell className="text-stone-600 text-sm">
                  {column.sampleValues
                    .slice(0, 3)
                    .map((v) => (v === null ? "" : String(v)))
                    .join(", ")}
                  {column.sampleValues.length > 3 && "..."}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
